import API from "../API";
import { actionPending, actionSuccess, actionError } from '../index';
import { toast } from 'react-toastify';
import { toastSuccess } from "../../components/toast/Toast";

export const MEMBER_REGISTER_PENDING = 'MEMBER_REGISTER_PENDING'
export const MEMBER_REGISTER_SUCCESS = 'MEMBER_REGISTER_SUCCESS'
export const MEMBER_REGISTER_ERROR = 'MEMBER_REGISTER_ERROR'

const MEMBER_REGISTER_URL = 'auth/register';

export function memberRegister(param = {}, resolve, reject, callback) {
    return dispatch => {
        dispatch(actionPending(MEMBER_REGISTER_PENDING));
        API.post(MEMBER_REGISTER_URL, param)
            .then(res => {
                if (res.error) {
                    throw (res.error);
                }
                dispatch(actionSuccess(MEMBER_REGISTER_SUCCESS, res.data));
                if (resolve) {
                    resolve({
                        data: res.data.data,
                    })
                }
                toastSuccess("Registrasi Berhasil. Silahkan cek email Anda untuk mengatur password ");
                if (callback) {
                    callback();
                }
            })
            .catch(error => {
                dispatch(actionError(MEMBER_REGISTER_ERROR, error));
                if (error.response && error.response.status === 500) {
                    toast.error(error.response.data.message, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true
                    });
                } else {
                    toast.error(error.toString(), {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true
                    });
                }
            })
    };
}